import request from '../request'

export default {
    getLayers() {
        return request.get('layer')
    },
    updaloadLayer(data) {
        return request.post('layer', data)
    },
    importService(data) {
        return request.post('layer/importService', data)
    },
    deleteLayerItem(layerId, code) {
        return request.delete(`layer/${layerId}?code=${code}`)
    },
    deleteGroupItem(groupId) {
      return request.delete(`layer/group/${groupId}`);
    },
    createLayerGroup(data) {
        return request.post('layer/group', data)
    },
    renameItem(data) {
        return request.put('layer/rename', data)
    },
    downloadLayerItem(data) {
        return request.post(`layer/download`, data, { responseType: 'blob' })
    }
}
